import { gql, TypedDocumentNode } from '@common/hooks';
import { SimpleFileFragmentType } from '@common/graphql';

export type DocumentByIdResponse = {
  documentById: SimpleFileFragmentType;
};

export type DocumentByIdVariables = {
  id: string;
};

export const DocumentByIdQuery: TypedDocumentNode<
  DocumentByIdResponse,
  DocumentByIdVariables
> = gql`
  query documentById($id: ID!) {
    documentById(id: $id) {
      id
      createdAt
      downloadUrl
      filename
      previewUrl
      contentType
    }
  }
`;
